<template>
    <div v-if="!editMode" style="flex-flow: row; display: flex; width: fit-content;">
        <span style="display: flex; flex-flow: row; min-width: fit-content;">{{ (editedText == -1) ? "Не указано" : editedText }} <slot></slot></span>
        <span class="textEdit__button" @click="toggleEditMode">Edit</span>
    </div>
    <div v-else class="textEdit" >
        <CInput
            :validationFunction="EDvalidationFunction"
            v-model="editedText"
            @blur="saveAndExit"
            @keydown.enter="saveAndExit"
            ref="input_editableText"
            @error="handleInputError"
            className="forminput editInput"
            id="editableText"
            name="editableText"
        />
        <slot></slot>
        <span class="textEdit__button" @click="saveAndExit">Save</span>
    </div>
</template>

<script>
import CInput from './InputComponent.vue';

export default {
    components: {
        CInput
    },
    props: {
        variableName: String,
        initialText: String,
        EDvalidationFunction: { type: Function },
        ajaxFunction: { type: Function },
        updateTextCallback: { type: Function }
    },
    data() {
        return {
            editMode: false,
            editedText: this.initialText,
            previousText: ''
        };
    },
    computed: {
        text() {
            return this.editedText;
        }
    },
    methods: {
        handleInputError(data) {
            if (!this.editMode) {
                console.log(data);
            }
        },
        toggleEditMode() {
            this.editMode = true;
        },
        saveAndExit() {
            if (this.editedText !== this.previousText) {
                if (this.ajaxFunction) {
                    this.$nextTick(() => {
                        this.ajaxFunction(this.editedText);
                    });
                }
            }
            if (this.updateTextCallback) {
                this.updateTextCallback(this.editedText);
                this.$emit('updateTextCallback', this.editedText), this.variableName;
            }
            this.previousText = this.editedText;
            this.$emit('saved', this.editedText, this.variableName);
            this.editMode = false;
        }
    }
};
</script>

<style>
.textEdit{
    width: fit-content;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    transition-duration: 0.25s;
}

.textEdit__button {
    position: relative;
    margin-left: 10px;
    transition-duration: 0.25s;
}

.editInput {
    width: fit-content; 
    padding-top: 0;
    padding-left: 0;
    padding-right: 0 ;
    border-radius: 5px;
    margin-bottom: 5px;
    transition-duration: 0.25s;
}

.editInput input {
    width: fit-content; 
    height: 38px;
    padding-left: 11px;
    font-size: 14px ;
    border-radius: 5px;
    transition-duration: 0.25s;
}

.forminput.editInput input,
.forminput.editInput textarea {
    width: fit-content;
    height: 38px;
    padding-top: 0;
    padding-left: 15px;
    padding-right: 0;
    border-radius: 5px;
    transition-duration: 0.25s;
}
</style>